exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".create-menu__link--small{padding:.5rem}.create-menu__link--small svg{width:100%;height:100%}.create-menu__link--small path{fill:#374651}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/CreateMenu/CreateMenuLinkSmall/CreateMenuLinkSmall.scss
// module id = 674
// module chunks = 0